module.exports = __webpack_public_path__ + "static/attach-videos-1-18314e52e8422c039f782c7e47a16666.jpg";